export function hasEmailDomain(email, domain) {
  const normalizedDomain = String(domain || '')
    .trim()
    .replace(/^@/, '')
    .toLowerCase();
  if (!email || !normalizedDomain) return false;
  return String(email).toLowerCase().endsWith(`@${normalizedDomain}`);
}

export function isBridgecareEmail(email) {
  return hasEmailDomain(email, 'getbridgecare.com');
}
